/* Created by Interactive 63 - https://interactive63.com */
/**
 * The product and studio names shown in the editor and written into exports. Kept in one place so
 * the credit text, the About dialog and the header links always agree.
 */

export const PRODUCT_NAME = 'SVG Tweener';
export const STUDIO_NAME = 'Interactive 63';
export const STUDIO_URL = 'https://interactive63.com';

/** Extension for saved project files. The contents are JSON, but the name says whose file it is. */
export const PROJECT_FILE_EXTENSION = '.tweener';

/** The credit line written into every code export. */
export const CREDIT_TEXT = `Animated with ${PRODUCT_NAME} by ${STUDIO_NAME} - ${STUDIO_URL}`;
